import React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import FieldHelpText from '~components/forms/HelpText';

function CheckboxGroup({
  name,
  extraLabelledBy,
  children,
  errors,
  helpText,
  required,
}) {
  const [field, meta] = useField(name);
  const error = !!(meta.touched && meta.error) || !!errors?.[name];
  const ariaLabels = [`label__${name}`];

  if (extraLabelledBy) {
    ariaLabels.push(extraLabelledBy);
  }

  if (helpText) {
    ariaLabels.push(`helptext__${name}`);
  }

  const ariaLabelledBy = ariaLabels.join(' ');

  return (
    <div className='form-control'>
      <label
        htmlFor={name}
        id={`label__${name}`}
        className='label block cursor-pointer px-0'
      >
        <input
          type='checkbox'
          className='checkbox absolute border-neutral'
          name={name}
          id={name}
          aria-labelledby={ariaLabelledBy}
          required={required}
          {...field}
          checked={field.value}
        />
        <span className='label-text inline-block pl-10 text-base [&>div>p]:last:mb-0 [&>div>p]:last:text-base'>
          {children}
        </span>
      </label>
      {error && (
        <FieldHelpText isError>{meta.error || errors?.[name]}</FieldHelpText>
      )}
      {helpText && (
        <FieldHelpText id={`helptext__${name}`}>{helpText}</FieldHelpText>
      )}
    </div>
  );
}

CheckboxGroup.propTypes = {
  name: PropTypes.string.isRequired,
  extraLabelledBy: PropTypes.string,
  children: PropTypes.node.isRequired,
  errors: PropTypes.object.isRequired,
  helpText: PropTypes.string,
  required: PropTypes.bool,
};

export default CheckboxGroup;
